import { breakpoints } from '../types/Responsive.js';

function isResponsiveObject(property) {
    return (typeof property === 'object' &&
        Object.keys(property).some(key => breakpoints.includes(key)));
}

export { isResponsiveObject };
//# sourceMappingURL=isResponsiveObject.js.map
